// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"video_wrapper__9msNo","video":"video_video__Bgj58","caption":"video_caption__Gf595"};